/**
 * Created by Kieran on 26/09/2017.
 */


import axios from 'axios'
import config from '../../config'
/**
 * @type {{searchSurgeriesByQuery: ((filter?)=>(*))}}
 */
let SurgerySearchApi = {
  /**
   * @param filter
   * @returns {AxiosPromise|*|Observable<AjaxResponse>}
   */
  searchSurgeriesByQuery(filter) {
    return axios.post(config.apiUrl + 'surgery/search/', {
      query: filter
    })
  }
}

export default SurgerySearchApi



// WEBPACK FOOTER //
// ./src/api/Surgery/index.js